
export const filterMode = {
  explore: {
    icon: 'icon-explore',
  },
  chart: {
    icon: 'icon-chart',
  },
  'chart-area': {
    icon: 'icon-chart-area',
  },
  stat: {
    icon: 'icon-stat',
  },
  report: {
    icon: 'icon-report',
  },
  reports: {
    icon: 'icon-table',
  },
  tree: {
    icon: 'icon-flow-split',
  },
};



// WEBPACK FOOTER //
// ./src/common/filter-mode.js